import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import '../../../../assets/stylesheets/Header.scss';
import { getGlobalAccountBalance, getCountOfUnreadMessages } from "../../../../store/selectors";
import Notification from '../../../Units/Notification';

const Header = () => {
    const { t } = useTranslation();
    const globalBalance = useSelector(getGlobalAccountBalance);
    const countOfUnreadMessages = useSelector(getCountOfUnreadMessages);

    return (<div className="slider-header">
        <div className="headerMainContainer">
            <span className="clubText">{t('tutorial.clubs')}</span>
            <div className="balanceItem">
                <span className="coinBalance">
                    <span className={'coinIcon'}></span>
                    <span className="balanceNumber">{globalBalance.money}</span>
                    {/* <button className="plus plusButton"></button> */}
                </span>
            </div>
            <Link to="/messages" className={`msgOpener newMessage`}>
                <span className={`openMessages`}></span>
                {/* <Notification count={countOfUnreadMessages} /> */}
            </Link>
        </div>
    </div>)
}

export default withRouter(Header);
